export default defineAppConfig({
  ui: {
    colors: {
      primary: "blue",
      secondary: "gray",
      warning: "orange",
    },
  },
});
